module.exports = __webpack_public_path__ + "img/tablet-screen-button.38e98592.svg";